import React from 'react';
import { LazyScreen } from '@apps/guest/packages/layout-engine/widgets/Custom/components/LazyScreen/LazyScreen';
import type { LazyScreenProps } from '@apps/guest/packages/layout-engine/widgets/Custom/components/LazyScreen/LazyScreen.types';
import { useSkipInitialAnimation } from '@apps/guest/packages/layout-engine/hooks/useSkipInitialAnimation';

/**
 * SSR-aware wrapper around LazyScreen. On the initial SSR mount (before
 * hydration), skips the skeleton so preloaded images appear immediately.
 * On subsequent client-side navigations, shows the skeleton normally.
 */
export const SsrLazyScreen: React.FC<LazyScreenProps> = props => {
  const skipAnimation = useSkipInitialAnimation();
  return (
    <LazyScreen
      {...props}
      showSkeleton={skipAnimation ? false : props.showSkeleton}
    />
  );
};
